module.exports = __webpack_public_path__ + "img/more2.ce8c0de8.png";